module.exports = __webpack_public_path__ + "img/card-demand.8060f3ea.png";